export default {
    "home":"Home",
    "subsidiaries":"Subsidiaries",

    "p1":"Established in 2013,",
    "p2":"Shengli Energy",
    "p3":"is your reliable supplier for safe, quality, efficient & durable lithium batteries solutions!",
    "p4":"With a total 2000 employees, Shengli Energy is a high-tech enterprise specializing in the development & production of 3C batteries, lithium-ion power batteries, energy storage batteries, portable power station, battery management systems and IoT applications, committed to become a world leader in lithium-ion battery industry as well-known as Tesla, Panasonic, LG, EVE, CATL, etc. Our main customers includes: Honeywell, Huawei, Bosch, Philips, etc.",
    "p5":"Strict & sophisticated quality management system (QMS) was built in the past several years as customer’s safety & satisfaction is our core principle of our products & services. Not only Shengli Energy has passed the ISO 9001:2008 certification, but most importantly, our battery products are UL, CB, KC, PSE, 3C, CE, FCC, UN38.3, IEC 62133, RoHS, TUV, MSDS certified.",
    "p6":"All the Shengli Energy battery products are insured by Ping An Insurance (Group) Company of China, Ltd. – one of oldest & biggest insurance company in mainland China, insure you of a huge indemnity of RMB 50,000,000, which is equivalent to USD 6,900,000.",
    "p7":"Through 10 years continuous reorganization and mergers & acquisitions, Shengli Energy has laid out a relatively complete upstream and downstream industrial chain of lithium batteries to provide global customers with a truly efficient & matched one-stop solution, and has been recognized as the China’s major manufacturers of lithium batteries.",
    "p8":"Shengli Energy’s subsidiaries & branches:",
    "p9":"R&D Center: Guangdong Shengli Hi-tech Energy Technology Co. Ltd.",
    "p10":"Lithium Battery Cells & Battery Pack Manufacturing Base: Dongguan Shengli Energy Technology Co., Ltd.",
    "p11":"18650 & 21700 & 26650 Lithium Batteries Manufacturing Base: Hunan Shengli High-tech Energy Technology Co., Ltd.",
    "p12":"3C Batteries Manufacturing Base: Hunan Shengyong Energy Technology Co., Ltd.",
    "p13":"Lithium Battery Powered Electric Bicycle Manufacturing Base: Dongguan Zhisheng Technology Co., Ltd.",
    "p14":"Global Marketing Center: Shenzhen Shengliqiang Technology Co., Ltd.",
    "p15":"Up to now, the products that have achieved mass production are as follows:",
    "p16":"INR18650 Lithium Batteries",
    "p17":"Lithium Phosphate (LFP) Batteries",
    "p18":"Lithium Polymer Batteries",
    "p19":"Shengli Energy has been providing high quality OEM/ODM services for Fortune 500 for over 6 years, please feel free to contact us if you need custom logo, private labeling, or full custom services!",
    "p20":"Shengli, Mr. Li, Kanavano, MIDONKEY are registered trademarks of Shengli Energy Corporation.",

    "but1":"All Certificates",
    "but2":"Contact Now",

    "support":"Support",
    "contact":"Contact Us",
    "custom":"Custom Services",
    "faq":"FAQ",
    "exchange":"Returns & Exchange",
    "delivery":"Shipping & Delivery",
    "bike":"Bike Registration",
    "warranty":"Warranty",
    "catalogues":"Catalogues",
    "guides":"Manuals & User Guides",
    "signup":"Newsletter Signup",
    "recycling":"Recycling",
  };
  